<template>
  <div class="editor-controls">
    <GbButton
      v-if="!readOnly"
      :gbTheme="isEditMode ? 'greenPrimary' : 'bluePrimary'"
      size="xs"
      @click="$emit('toggle')"
      @mousedown.prevent
      :aria-label="toggleAriaLabel"
      class="mr-1 w-16"
    >
      <span class="material-icons-round pr-1 text-lg">edit</span>
      {{ isEditMode ? 'Done' : 'Edit' }}
    </GbButton>
    <CopyButton
      :stringToCopy="textToCopy"
      :tooltipText="copyTooltipText"
      :ariaLabel="copyAriaLabel"
      buttonText="Copy"
      buttonTheme="grayOutlineSecondary"
      customClass="bg-white w-16"
      :autoHideTooltip="true"
      :showCopiedCheck="showCopiedCheck"
      size="xs"
      iconClass="material-icons-outlined"
    />
  </div>
</template>

<script lang="ts">
import GbButton from '@/components/GbButton.vue'
import CopyButton from '@/components/CopyButton.vue'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'WikiTextEditorControls',
  components: {
    GbButton,
    CopyButton
  },
  props: {
    isEditMode: {
      type: Boolean,
      required: true
    },
    textToCopy: {
      type: String,
      required: false,
      default: ''
    },
    readOnly: {
      type: Boolean,
      required: false,
      default: false
    },
    copyTooltipText: {
      type: String,
      required: false,
      default: 'Statement copied'
    },
    showCopiedCheck: {
      type: Boolean,
      required: false,
      default: false
    },
    contentLabel: {
      type: String,
      required: false,
      default: ''
    }
  },
  emits: ['toggle'],
  computed: {
    toggleAriaLabel(): string {
      if (!this.contentLabel) {
        return this.isEditMode ? 'Done, save changes' : 'Edit text'
      }
      return this.isEditMode ? `Done, save ${this.contentLabel}` : `Edit ${this.contentLabel}`
    },
    copyAriaLabel(): string | undefined {
      return this.contentLabel ? `Copy ${this.contentLabel}` : undefined
    }
  }
})
</script>
